import i18n from "../../i18n";
import React from "react";
import { Table, Text } from "@mantine/core";

const SubledgerReconciliationView = ({ reports = [] }) => (
  <>
    <Table striped withBorder>
      <thead>
        <tr>
          <th>{i18n.t("Subledger")}</th>
          <th>{i18n.t("Control Account")}</th>
          <th>{i18n.t("Subledger Balance")}</th>
          <th>{i18n.t("GL Balance")}</th>
          <th>{i18n.t("Difference")}</th>
        </tr>
      </thead>
      <tbody>
        {reports.map((row) => (
          <tr key={row.type}>
            <td>{row.type}</td>
            <td>{row.accountCode}</td>
            <td>{row.subledgerBalance}</td>
            <td>{row.glBalance}</td>
            <td>{row.difference}</td>
          </tr>
        ))}
      </tbody>
    </Table>
    {reports.length === 0 && (
      <Text size="sm" color="dimmed" mt="md">
        No reconciliation data yet.
      </Text>
    )}
  </>
);

export default SubledgerReconciliationView;
